// src/components/OrderEntry/utils/parsers.js
// =============================================================================
// PARSING & FORMATTING UTILITIES
// =============================================================================
// Extracted from OrderEntry.jsx BLOCK OE.7
// These utilities handle quantity/money parsing and formatting
// =============================================================================

/**
 * Parse a string value to integer quantity
 * Strips all non-digit characters before parsing
 *
 * @param {string|number} val - Raw value to parse
 * @returns {number|null} Parsed integer or null if invalid
 */
export function parseQtyInt(val) {
  const s = String(val ?? '').trim();
  if (!s) {
    return null;
  }

  const cleaned = s.replace(/[^\d]/g, '');
  if (!cleaned) {
    return null;
  }

  const n = parseInt(cleaned, 10);
  return Number.isFinite(n) ? n : null;
}

/**
 * Parse a string value to money number (removes $ and ,)
 *
 * @param {string|number} val - Raw money value
 * @returns {number|null} Parsed number or null if invalid
 */
export function parseMoneyNumber(val) {
  const s = String(val ?? '').trim();
  if (!s) {
    return null;
  }

  const n = Number(s.replace(/[$,]/g, ''));
  return Number.isFinite(n) ? n : null;
}

/**
 * Format a number as USD currency
 *
 * @param {number} n - Number to format
 * @returns {string} Formatted USD string (e.g., "$1,234.56")
 */
export function formatUSD(n) {
  return Number(n).toLocaleString(undefined, { style: 'currency', currency: 'USD' });
}

/**
 * Format money input value (keeps 2 decimal places)
 * Used for input fields to ensure consistent decimal formatting
 *
 * @param {string|number} val - Raw money value
 * @returns {string} Formatted money string with 2 decimals
 */
export function formatMoneyInput(val) {
  if (val == null) {
    return '';
  }

  const s = String(val).trim();
  if (!s) {
    return '';
  }

  const cleaned = s.replace(/[$,]/g, '');
  const n = Number(cleaned);
  if (Number.isNaN(n)) {
    return s;
  }

  return n.toFixed(2);
}
